import { render } from "./TermsView.vue?vue&type=template&id=6e908863&ts=true"
import script from "./TermsView.vue?vue&type=script&lang=ts"
export * from "./TermsView.vue?vue&type=script&lang=ts"

import "./TermsView.vue?vue&type=style&index=0&id=6e908863&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__